import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Card } from 'react-bootstrap';
import { FaKey } from 'react-icons/fa';
import AuthContext from '../../context/AuthContext';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [formError, setFormError] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('danger');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const { isAuthenticated, forgotPassword } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const onChange = e => {
    setEmail(e.target.value);
    setFormError('');
  };

  const validateForm = () => {
    if (!email.trim()) {
      setFormError('Email is required');
      return false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setFormError('Email is invalid');
      return false;
    }
    return true;
  };

  const onSubmit = async e => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    setAlertMessage('');
    
    const result = await forgotPassword(email);
    
    setIsSubmitting(false);
    
    if (result.success) {
      setAlertType('success');
      setAlertMessage('Password reset instructions have been sent to your email.');
      setIsSubmitted(true);
    } else {
      setAlertType('danger');
      setAlertMessage(result.error);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-logo">
        <h1>Optical Data Manager</h1>
      </div>
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">
            <FaKey className="me-2" />
            Forgot Password
          </h2>
          
          {alertMessage && (
            <Alert variant={alertType} onClose={() => setAlertMessage('')} dismissible>
              {alertMessage}
            </Alert>
          )}
          
          {!isSubmitted ? (
            <Form onSubmit={onSubmit}>
              <p className="text-muted mb-4">
                Enter your email address and we'll send you instructions to reset your password.
              </p>
              
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={onChange}
                  placeholder="Enter your email"
                  isInvalid={!!formError}
                />
                <Form.Control.Feedback type="invalid">
                  {formError}
                </Form.Control.Feedback>
              </Form.Group>
              
              <Button 
                variant="primary" 
                type="submit" 
                className="w-100 mt-3" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </Form>
          ) : (
            <div className="text-center">
              <p>Check your email for further instructions.</p>
              <Button 
                variant="outline-primary" 
                onClick={() => {
                  setEmail('');
                  setIsSubmitted(false);
                  setAlertMessage('');
                }}
              >
                Try Another Email
              </Button>
            </div>
          )}
          
          <hr />
          
          <div className="text-center">
            <Link to="/login">Back to Login</Link>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ForgotPassword;
